<template>
  <div>
    <slot name="button" :openPanel="openPanel"> </slot>
    <b-sidebar id="sidebar-contract" width="600px" backdrop-variant="dark" backdrop right shadow :visible="value"
      @change="$emit('input', $event)" @hidden="onHidden">
      <template #header>
        <div class="sidebar-header-container d-flex justify-content-between align-items-center w-100">
          <span class="sidebar-title-text">
            {{ $t('seller.contracts.quick_view.text_8007') }}
          </span>
          <b-button variant="link" class="text-decoration-none p-0" @click="closePanel">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M6 6L18 18" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </b-button>
        </div>
      </template>
      <b-container fluid class="container-sidebar">
        <b-row class="panel">
          <b-col>
            <b-overlay :show="loading">
              <b-row class="item-dados">
                <b-col class="sumary">

                  <!-- ############# Início Informações do produto ############# -->
                  <b-row class="item-dados-produto item-dados">

                    <b-col cols="12">
                      <div class="product-main">
                        <div class="img-product">
                          <img :src="contract.contract.live.product.images[0].path
                            " v-if="
                              !loading &&
                              contract.contract.live.product &&
                              contract.contract.live.product.images.length
                            " />
                        </div>
                        <div class="name-product d-flex flex-column justify-content-between h-100"
                          v-if="!loading && contract.contract.live.product">
                          <div class="d-flex align-items-center" style="gap: 0.25rem;">
                            <span>
                              {{$t('seller.contracts.quick_view.text_1794')}}:#{{ contract.contract.live.product.id }}
                            </span>
                            <div v-if="isExtension || isPosGraduation" v-b-tooltip.hover class="mb-1" :title="getProductIdIconTooltip()">
                              <img :src="require('@/assets/svg/student-hat.svg')" alt="Chapéu de estudante"/>
                            </div>
                          </div>

                          <p class="mb-0 name-product-title">{{ contract.contract.live.product.name }}</p>

                          <div>
                            <p class="hash mb-0" v-if="contract.contract.offer">
                              Código da Oferta:
                              {{ contract.contract.offer.hash }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </b-col>
                  </b-row>

                  <!-- ############# INFORMAÇÕES DA ASSINATURA ############# -->
                  <b-row class="mb-3 item-dados">
                    <b-col cols="12">
                      <h5 class="titulo-item">
                        {{ $t('seller.contracts.quick_view.text_2839') }}
                      </h5>
                    </b-col>
                    <!-- ID -->
                    <b-col cols="12" class="d-flex justify-content-between align-items-center">
                      <p class="label-campo mb-0">
                        {{ $t('seller.contracts.quick_view.text_1800') }}:
                      </p>
                      <p class="dados-campo mb-0">{{ internalContractId }}</p>
                    </b-col>

                    <!-- STATUS -->
                    <b-col cols="12" class="d-flex justify-content-between align-items-center mt-3">
                      <p class="label-campo mb-0">
                        {{ $t('seller.contracts.quick_view.text_1790') }}:
                      </p>
                      <p class="dados-campo mb-0" :class="getBadge(contract.status)">
                        {{ getStatusText(contract.status) }}
                      </p>
                    </b-col>

                    <!-- DATA AQUISIÇÃO -->
                    <b-col cols="12" class="d-flex justify-content-between align-items-center mt-3">
                      <p class="label-campo mb-0">
                        {{ getBeginningDateLabel() }}:
                      </p>
                      <p class="dados-campo mb-0">
                        {{ formatContractCreatedAt(contract.created_at) }}
                      </p>
                    </b-col>

                    <!-- DATA VENCIMENTO -->
                    <b-col cols="12" class="d-flex justify-content-between align-items-center mt-3">
                      <p class="label-campo mb-0">
                        {{ getNextExpirationDateLabel() }}:
                      </p>
                      <p class="dados-campo mb-0">
                        {{ currentPeriodEnd }}
                      </p>
                    </b-col>
                  </b-row>

                  <!-- #################### TIPO DE ASSINATURA E METODO DE PAGAMENTO #################### -->
                  <b-row class="mb-3">

                    <!-- METHOD -->
                    <b-col cols="12" class="d-flex justify-content-between align-items-center">
                      <p class="label-campo mb-0">
                        {{ $t('seller.contracts.quick_view.text_1793') }}:
                      </p>
                      <p class="dados-campo mb-0">
                        {{ getMethod() }}
                      </p>
                    </b-col>

                    <!-- PARCELAS -->
                    <b-col cols="12" class="d-flex justify-content-between align-items-center mt-3">
                      <p class="label-campo mb-0">
                        Parcela da Assinatura:
                      </p>
                      <p class="dados-campo mb-0">
                        {{ installmentSummary }}
                      </p>
                    </b-col>

                    <!-- VALOR BRUTO -->
                    <b-col cols="12" class="d-flex justify-content-between align-items-center mt-3">
                      <p class="label-campo mb-0">
                        Valor Bruto:
                      </p>
                      <p class="dados-campo mb-0">
                        {{ amount }}
                      </p>
                    </b-col>
                  </b-row>

                  <!-- #################### LOCAL CURRENCY E BASE CURRENCY #################### -->
                  <template v-if="
                    interAccess && contract.history && contract.history.length
                  ">
                    <!-- Local Currency -->
                    <b-col v-if="contract.history[0].local_currency != undefined" cols="12" class="mt-4">
                      <p class="label-campo mr-2">Moeda da compra:</p>
                      <span>{{ contract.history[0].local_currency.name }}</span>
                    </b-col>
                    <!-- Base Currency -->
                    <b-col v-if="contract.history[0].base_currency != undefined" cols="12" class="mt-4">
                      <p class="mr-2 label-campo">Valor recebido em:</p>
                      <section class="d-flex align-items-center">
                        <div class="chip" :style="setColors(
                          contract.history[0].base_currency.currency
                        )
                          ">
                          {{
                            contract.history[0].base_currency
                              ? contract.history[0].base_currency
                                .currency_symbol
                              : 'R$'
                          }}
                        </div>
                        <span>
                          {{ contract.history[0].base_currency.currency }}</span>
                      </section>
                    </b-col>
                    <!-- Country -->
                    <b-col v-if="contract.history[0].country != undefined" cols="12" class="mt-4">
                      <p class="mr-2 label-campo">Origem da compra:</p>
                      <section class="d-flex align-items-center">
                        <img class="mr-2" style="height: 30px" :src="require(`@/assets/locales/flag-${contract.history[0].country.country_code}.svg`)
                          " />
                        <span> {{ contract.history[0].country.name }}</span>
                      </section>
                    </b-col>
                  </template>
                </b-col>
              </b-row>

              <!-- #################### DETALHES DO CLIENTE  #################### -->
              <b-row class="item-dados">
                <b-col v-if="contract.client">
                  <h5 class="titulo-item">
                    {{ $t('seller.contracts.quick_view.text_1798') }}
                  </h5>

                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <p class="label-campo mb-0">
                      {{ $t('seller.contracts.quick_view.text_1796') }}:
                    </p>
                    <p class="dados-campo mb-0">{{ contract.client.name }}</p>
                  </div>

                  <div v-if="isSeller" class="d-flex justify-content-between align-items-center mb-3">
                    <p class="label-campo mb-0">
                      {{ $t('seller.contracts.quick_view.text_1797') }}:
                    </p>
                    <p class="dados-campo mb-0">{{ contract.client.email }}</p>
                  </div>

                  <!-- TELEFONE -->
                  <div v-if="isSeller" class="d-flex justify-content-between align-items-center mb-3">
                    <p class="label-campo mb-0">Telefone:</p>
                    <p class="dados-campo mb-0">
                      <span v-if="!contract.client.cellphone">-</span>
                      <span v-else-if="/\#/.test(contract.client.cellphone)">
                        {{ contract.client.cellphone }}
                      </span>
                      <span v-else>
                        {{ formatPhoneNumber(contract.client.cellphone) }}
                      </span>
                    </p>
                  </div>

                  <div v-if="isSeller" class="d-flex justify-content-between align-items-center mb-3">
                    <p class="label-campo mb-0">
                      {{ $t('seller.contracts.quick_view.text_1799') }}:
                    </p>
                    <p class="dados-campo mb-0">{{ contract.client.document }}</p>
                  </div>
                </b-col>
              </b-row>

              <!-- ###################### DADOS QDO AFILIADO #######################-->
              <b-row v-if="contract.affiliate" class="item-dados">
                <b-col>
                  <h5 class="titulo-item">
                    {{ $t('seller.contracts.quick_view.text_1795') }}
                  </h5>

                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <p class="label-campo mb-0">
                      {{ $t('seller.contracts.quick_view.text_1796') }}:
                    </p>
                    <p class="dados-campo mb-0">{{ contract.affiliate.name }}</p>
                  </div>

                  <div class="d-flex justify-content-between align-items-center">
                    <p class="label-campo mb-0">
                      {{ $t('seller.contracts.quick_view.text_1797') }}:
                    </p>
                    <p class="dados-campo mb-0">{{ contract.affiliate.email }}</p>
                  </div>
                </b-col>
              </b-row>

              <!-- #################### HISTÓRICO DE TRANSACOES  #################### -->
              <b-row v-if="hasHistory" class="item-dados mb-1">
                <b-col>
                  <h5 class="titulo-item">
                    {{ $t('seller.contracts.quick_view.text_1801') }}
                  </h5>

                  <table v-if="hasHistory" class="table-custom rounded-table">
                    <thead>
                      <tr>
                        <th nowrap>{{ $t('seller.contracts.quick_view.sale_id') }}</th>
                        <th nowrap>{{ $t('seller.contracts.quick_view.creation_date') }}</th>
                        <th nowrap>{{ $t('seller.contracts.quick_view.expiration_date') }}</th>
                        <th nowrap>{{ $t('seller.contracts.quick_view.payment_date') }}</th>
                        <th nowrap>{{ $t('seller.contracts.quick_view.amount') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in contract.history" :key="index">
                        <td>
                          <a :href="`/vendas?s_id=${item.id}`" target="_blank">{{ item.id }}</a>
                          <div v-if="item.has_retries" class="mt-1">
                            <a href="#" class="text-primary" @click.prevent="openChargeAttempts(item)">
                              Ver retentativas ({{ item.retry_count }})
                            </a>
                          </div>
                        </td>
                        <td>{{ formatCreatedAt(item) }}</td>
                        <td style="text-align: center;">{{ formatTableDateValueExpiration(item) }}</td>
                        <td>{{ formatPaidAt(item.paid_at) }}</td>
                        <td nowrap>
                          <span v-if="item.balance">
                            {{ 'R$ ' + formatMoney(item.balance) }}
                          </span>
                          <a v-else-if="item.method == 'BOLETO' && item.status != 'paid' && item.status != 'refunded' && item.status != 'chargedback'"
                            class="openB" :href="item.boleto_url" target="_blank">
                            {{ $t('seller.contracts.quick_view.text_1806') }}
                          </a>
                          <span v-else>
                            {{
                              contract.history && contract.history.length > 0 && contract.history[0].base_currency
                                ? contract.history[0].base_currency.currency_symbol + ' 0,00'
                                : 'R$ 0,00'
                            }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <table v-else-if="contract.status === 'trialing' && contract.history.length > 0"
                    class="table-custom rounded-table">
                    <thead>
                      <tr>
                        <th>Criação</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in contract.history" :key="index">
                        <td>{{ tableDateValueCreation(item) | date }}</td>
                        <td>{{ $t('seller.contracts.quick_view.trial_start_date') }}</td>
                      </tr>
                    </tbody>
                  </table>

                  <table v-else class="table-custom rounded-table">
                    <thead>
                      <tr>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ $t('seller.contracts.quick_view.text_247') }}</td>
                      </tr>
                    </tbody>
                  </table>

                </b-col>
              </b-row>

              <!-- ############# BOTÕES ############# -->

              <b-row class="my-4 item-dados">
                <b-col>
                  <b-row class="mt-4">
                    <b-col cols="6" class="pr-2">
                      <!-- Coluna 1 -->
                      <BaseConfirmDialog @confirmed="cancelContract" id="btn-cancela-contrato">
                        <template v-slot:button="{ openModal }">
                          <b-button class="custom-button custom-button-encerrar-contrato"
                            :disabled="shouldDisableCancelContract"
                            @click="openModal">
                            Encerrar Contrato
                          </b-button>
                        </template>
                      </BaseConfirmDialog>
                    </b-col>
                    <b-col cols="6" class="pl-2">
                      <!-- Coluna 2 -->
                      <Affiliation v-if="canShowAssignAffiliate" 
                      :product_id="contract.contract.product_id" from="contract" @close="fetchContract">
                        <template v-slot:button="{ openModal }">

                          <b-button class="custom-button custom-button-atribuir-afiliado"
                            @click="openModal(contract_id)">
                            Atribuir Afiliado
                          </b-button>
                        </template>
                      </Affiliation>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12">
                      <!-- Coluna 3 -->
                      <b-button
                        v-if="canShowUpdateContract"
                        class="custom-button custom-button-atualizar-assinatura" :disabled="contract.status == 'canceled' ||
                          contract.status == 'CANCELED' ||
                          contract.status == 'ended' ||
                          contract.status == 'ENDED'" @click="copyToClipboard">
                        <span class="d-flex align-items-center justify-content-center">
                          Atualizar Assinatura
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fff" viewBox="0 0 24 24"
                            class="ml-2">
                            <path
                              d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
                          </svg>
                        </span>
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-overlay>
          </b-col>
        </b-row>
      </b-container>
    </b-sidebar>

    <b-modal
      id="contract-charge-attempts-modal"
      title="Retentativas da Parcela"
      size="lg"
      hide-footer
      @hidden="resetChargeAttempts"
    >
      <p class="mb-3 text-muted">
        Tentativas de cobrança do ciclo
        <strong>{{ chargeAttemptsCurrent }}</strong>, incluindo recusas.
      </p>
      <div v-if="chargeAttemptsLoading" class="text-center py-4">
        <b-spinner small />
      </div>
      <table v-else class="table table-sm table-bordered">
        <thead>
          <tr>
            <th>ID</th>
            <th>Status</th>
            <th>Criação</th>
            <th>Valor</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="attempt in chargeAttempts" :key="attempt.id">
            <td>
              <a :href="`/vendas?s_id=${attempt.id}`" target="_blank">{{ attempt.id }}</a>
            </td>
            <td>{{ saleStatusLabel(attempt.status) }}</td>
            <td>{{ formatCreatedAt(attempt) }}</td>
            <td nowrap>
              <span class="d-inline-flex align-items-center">
                <font-awesome-icon
                  v-if="attempt.method && attempt.method !== 'TWO_CREDIT_CARDS'"
                  :icon="getIconMethod(attempt.method)"
                  class="icon-gray mr-2"
                  :id="`attempt-method-icon-${attempt.id}`"
                />
                <template v-else-if="attempt.method === 'TWO_CREDIT_CARDS'">
                  <span class="attempt-method-two-cards mr-2">
                    <font-awesome-icon
                      icon="credit-card"
                      class="icon-gray"
                      :id="`attempt-method-icon-${attempt.id}`"
                    />
                    <font-awesome-icon
                      icon="credit-card"
                      class="icon-gray TWO_CREDIT_CARDS"
                    />
                  </span>
                </template>
                <b-tooltip
                  v-if="attempt.method"
                  :target="`attempt-method-icon-${attempt.id}`"
                  :title="getMethodLabel(attempt.method)"
                  placement="left"
                />
                <span>
                  {{
                    attempt.balance
                      ? 'R$ ' + formatMoney(attempt.balance)
                      : 'R$ 0,00'
                  }}
                </span>
              </span>
            </td>
          </tr>
          <tr v-if="!chargeAttempts.length">
            <td colspan="4" class="text-center text-muted">
              Nenhuma tentativa encontrada.
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </div>
</template>
<script>
import Affiliation from '@/components/shared/modals/Affiliation'
import Utils from "@/mixins/utils";
import { textMethod, iconMethod } from '@/helpers.js'
import { EventBus } from '@/main.js'
import Money from '@/mixins/money'
import ContractService from '@/services/resources/ContractService'
import moment from 'moment'
import Subscription from "./modals/Subscription"
import { subscriptionStatusLabel } from '@/helpers/subscriptionStatusTranslate';

const service = ContractService.build()

export default {
  name: 'ContractQuickView',
  components: {
    Affiliation,
    Subscription
  },
  mixins: [Utils, Money],
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    contract_id: {
      type: [String, Number],
      default: ""
    },
    updateQueryParams: {
      type: Function,
      default: () => { }
    },
    initialData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: true,
      collapse: false,
      is_btn_disable: false,
      internalContractId: '',
      contract: {
        id: null,
        status: null,
        current_period_end: null,
        contract: {
          live: {
            product: {
              name: "",
              description: "",
              images: [{ path: null }]
            }
          }
        },
        client: null,
        affiliate: null,
      },
      interAccess: false,
      link_checkout: process.env.VUE_ADM_PAGE,
      installmentSummary: null,
      chargeAttempts: [],
      chargeAttemptsCurrent: null,
      chargeAttemptsLoading: false,
    }
  },
  watch: {
    value(newValue) {
      this.$emit('input', newValue);
    },
    contract_id: {
      immediate: true,
      handler(newValue) {
        this.internalContractId = String(newValue);
      }
    }
  },
  filters: {
    date(date) {
      return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    currency(value) {
      if (!value) return 'R$ 0,00';
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(value);
    }
  },
  created() {
    let userInterIds = process.env.USER_INTER.substring(
      1,
      process.env.USER_INTER.length - 1
    ).split(',')
    this.interAccess = userInterIds.some(
      userId => parseInt(userId) === this.userID
    )
  },
  computed: {
    productFormat() {
      return this.contract.contract.live.product.format;
    },
    isExtension(){
      return this.productFormat === 'EXTENSION_COURSE';
    },
    isPosGraduation(){
      return this.productFormat === 'POS_GRADUATION';
    },
    hasHistory() {
      return this.contract.history && this.contract.history.length
    },
    amount() {
      if (!this.contract.history || !this.contract.history.length) {
        return '-'
      }

      const sale = this.contract.history[0];
      let symbol = 'R$';

      if (sale) {
        symbol = sale.base_currency ? sale.base_currency.currency_symbol : 'R$';
      }

      if (this.contract && this.contract.amount) {
        return `${symbol} ${this.formatMoney(this.contract.amount)}`;
      }
      return `${symbol} 0,00`;
    },

    salesPage() {
      try {
        // Use optional chaining for safer access
        const id_produto = this.contract?.contract?.live?.product?.id;
        const offer_hash = this.contract?.contract?.offer?.hash;
        const client_name = this.contract?.client?.name;
        const client_document = this.contract?.client?.document;
        const client_id = this.contract?.client?.id; // Correct source

        if (!id_produto) {
          throw new Error('Produto não encontrado');
        }

        let baseUrl = `${process.env.VUE_SALES_PAGE}/assinatura/${id_produto}`;

        // Add offer hash if it exists (mimicking rightPreview's potential structure)
        // Note: This assumes offer_hash exists if the path segment is included
        if (offer_hash) {
          baseUrl += `/offer/${offer_hash}`;
        }

        // Build query parameters using encodeURIComponent for safety
        const params = [];
        if (client_name !== undefined && client_name !== null) {
          params.push(`fn=${encodeURIComponent(client_name)}`);
        }
        if (client_document !== undefined && client_document !== null) {
          params.push(`document=${encodeURIComponent(client_document)}`);
        }
        // Always add client_id, using client.id as source
        params.push(`client_id=${client_id !== undefined && client_id !== null ? client_id : ''}`);

        // Combine base URL and parameters
        return `${baseUrl}?${params.join('&')}`;

      } catch (error) {
        console.error('Erro ao gerar URL:', error);
        return ''; // Return empty string on error
      }
    },
    formattedDateDescription() {
      if (this.contract && this.contract.history && this.contract.history > 0 && this.contract.history[0].method === 'BOLETO') {
        return this.$t('seller.contracts.quick_view.expiration_date')
      }

      return this.$t('seller.contracts.quick_view.text_1803')
    },
    currentPeriodEnd() {
      if (this.contract && this.contract.status === 'canceled' && this.contract.cancellation_date) {
        const cancellationDate = moment(this.contract.cancellation_date);
        return cancellationDate.isValid() ? cancellationDate.format('DD/MM/YYYY') : '-';
      }

      if (this.contract && this.contract.current_period_end) {
        const date = moment(this.contract.current_period_end);
        return date.isValid() ? date.format('DD/MM/YYYY') : '-';
      }
      return '-';
    },
    canShowAssignAffiliate() {
      const isSeller = this.contract.seller_id === this.userID;
      const hasNoAffiliate = !this.contract.affiliate;
      const isPaidOrActiveStatus = this.contract.status?.toLowerCase() === 'active' ||
          this.contract.status?.toLowerCase() === 'paid';
      const isNotPix = this.contract.method?.toLowerCase() === 'pix'
      const isBetaSeller = this.$store.getters.getProfile.is_beta_seller;

      return (
          isSeller 
          && hasNoAffiliate 
          && isPaidOrActiveStatus
          && isNotPix
          && !isBetaSeller
      );
    },
    shouldDisableCancelContract() {
      let forbiddenStatus = ['canceled','processing','ended'];
      let forbiddenMethods = ['pix'];

      return forbiddenStatus.includes(this.contract.status?.toLowerCase()) ||
        forbiddenMethods.includes(this.contract.method?.toLowerCase()) ||
        this.is_btn_disable;
    },
    canShowUpdateContract() {
      let allowedMethods = ['credit_card'];
      let hasHistory = (this.contract.history && this.contract.history.length > 0 );
      let isLastHistoryMethodAllowed = (hasHistory && allowedMethods.includes(this.contract.history[0].method?.toLowerCase()));

      return(
        allowedMethods.includes(this.contract.method?.toLowerCase()) ||
        isLastHistoryMethodAllowed
      );
    }
  },
  methods: {
    getProductIdIconTooltip() {
      return this.isExtension
          ? this.$t('common.product.format.EXTENSION_COURSE')
          : this.$t('common.product.format.POS_GRADUATION');
    },
    formatContractCreatedAt(createdAt) {
      if (!createdAt || createdAt === '') return '-';

      const date = moment.utc(String(createdAt)).subtract(3, 'hours');
      if (!date.isValid()) return '-';

      return date.format('DD/MM/YYYY');
    },
    closePanel() {
      this.$emit('input', false);
    },
    getMethod() {
      if (this.contract.history && this.contract.history.length) return textMethod(this.contract.history[0].method);
      if (this.contract.method) return textMethod(this.contract.method);

      return this.$t('seller.contracts.quick_view.text_1811');
    },
    formatPhoneNumber(phone) {
      if (!phone) return '-';

      // Remove todos os caracteres não numéricos
      const numbers = phone.replace(/\D/g, '');

      // Se já tiver o código do país, mantém
      if (phone.startsWith('+')) {
        if (numbers.length === 13 && numbers.startsWith('55')) {
          // Formato brasileiro: +55 (11) 96327-0717
          return `+55 (${numbers.substr(2, 2)}) ${numbers.substr(4, 5)}-${numbers.substr(9, 4)}`;
        }
        // Para outros países, mantém o formato original
        return phone;
      }

      // Se não tiver código do país e for número brasileiro (11 dígitos)
      if (numbers.length === 11) {
        return `+55 (${numbers.substr(0, 2)}) ${numbers.substr(2, 5)}-${numbers.substr(7, 4)}`;
      }

      // Se for número brasileiro sem o 9 (10 dígitos)
      if (numbers.length === 10) {
        return `+55 (${numbers.substr(0, 2)}) ${numbers.substr(2, 4)}-${numbers.substr(6, 4)}`;
      }

      // Para outros formatos, retorna como está
      return phone;
    },
    getProductType(type) {
      if (!type) {
        return { text: 'Unknown', class: 'icon-default' }  // Valor padrão se type for undefined ou inválido
      }
      let r = {}
      if (type) {
        switch (type) {
          case 'TRANSACTION': {
            r = {
              text: this.$t('seller.contracts.quick_view.text_255'),
              class: 'icon-black'
            }
            break
          }
          case 'SUBSCRIPTION': {
            r = {
              text: this.$t('seller.contracts.quick_view.text_254'),
              class: 'icon-black'
            }
            break
          }
          default: {
            r = { text: type, class: 'icon-black' }
            break
          }
        }
        return r
      }
    },
    getStatus(status) {
      let r = {}
      if (status) {
        switch (status.toLowerCase()) {
          case 'trialing': {
            r = {
              text: this.$t('seller.contracts.text_2481'),
              class: 'icon-black'
            }
            break
          }
          case 'processing': {
            r = {
              text: this.$t('seller.contracts.text_2472'),
              class: 'icon-black'
            }
            break
          }
          case 'paid': {
            r = {
              text: this.$t('seller.contracts.text_2473'),
              class: 'icon-black'
            }
            break
          }
          case 'pending_payment': {
            r = {
              text: this.$t('seller.contracts.text_2474'),
              class: 'icon-black'
            }
            break
          }
          case 'unpaid': {
            r = {
              text: this.$t('shared.status.unpaidSubscription'),
              class: 'icon-red'
            }
            break
          }
          case 'canceled': {
            r = {
              text: this.$t('seller.contracts.text_2458'),
              class: 'icon-red'
            }
            break
          }
          case 'ended': {
            r = {
              text: this.$t('seller.contracts.text_2459'),
              class: 'icon-red'
            }
            break
          }

          default: {
            r = { text: status, class: 'icon-black' }
            break
          }
        }
        return r
      } else return { text: status, class: 'icon-black' }
    },
    getStatus_sales(status) {
      let r = {}
      if (status) {
        switch (status.toLowerCase()) {
          case 'processing': {
            r = {
              text: this.$t('seller.contracts.text_2472'),
              class: 'is-light-blue'
            }
            break
          }
          case 'authorized': {
            r = {
              text: this.$t('seller.contracts.text_2473'),
              class: 'is-light-blue'
            }
            break
          }
          case 'paid': {
            r = {
              text: this.$t('seller.contracts.text_2473'),
              class: 'is-green'
            }
            break
          }
          case 'refunded': {
            r = { text: this.$t('seller.contracts.text_2475'), class: 'is-red' }
            break
          }

          case 'waiting_payment': {
            r = {
              text: this.$t('seller.contracts.text_2476'),
              class: 'is-warning'
            }
            break
          }
          case 'refund_pending':
          case 'pending_refund': {
            r = {
              text: this.$t('seller.contracts.text_2477'),
              class: 'is-warning'
            }
            break
          }
          case 'refused': {
            r = { text: this.$t('seller.contracts.text_2478'), class: 'is-red' }
            break
          }
          case 'chargedback': {
            r = {
              text: this.$t('seller.contracts.text_2479'),
              class: 'is-warning'
            }
            break
          }
          case 'delayed': {
            r = {
              text: this.$t('seller.contracts.text_2480'),
              class: 'is-green'
            }
            break
          }
          case 'trialing': {
            r = {
              text: this.$t('seller.contracts.text_2481'),
              class: 'is-black'
            }
            break
          }
          default: {
            r = { text: status, class: 'is-black' }
            break
          }
        }
        return r
      } else return { text: status, class: 'is-black' }
    },
    openSalesPage() {
      window.open(this.salesPage)
    },
    resetUrl() {
      if (Object.values(this.$route.query).length) {
        this.$router.push({ query: {} });
      }
      if (this.updateQueryParams) {
        this.updateQueryParams(true);
      }
    },
    openPanel(contractId, additionalData = {}) {
      this.loading = true;
      this.internalContractId = String(contractId);
      this.$emit('update:contract-id', this.internalContractId);
      this.$emit('input', true);

      // Atualiza os dados iniciais com as informações adicionais
      this.contract = {
        id: this.internalContractId,
        status: additionalData.status || null,
        method: additionalData.method || null,
        amount: additionalData.amount || null,
        client: {
          name: additionalData.client_name || null,
          email: additionalData.client_email || null,
          document: additionalData.document || null,
          cellphone: additionalData.cellphone || null
        },
        start_date: additionalData.start_date || null,
        current_period_end: additionalData.current_period_end || null,
        current_period: additionalData.installments ? additionalData.installments.split('/')[0] : '-',
        total_periods: additionalData.installments ? additionalData.installments.split('/')[1] : '-',
        contract: {
          live: {
            product: {
              name: '',
              description: '',
              images: [{ path: null }]
            }
          }
        }
      };

      this.fetchContract();
    },
    fetchContract() {
      this.loading = true;
      service
        .read({ id: this.internalContractId })
        .then(response => {
          // Mantém os dados que já temos e adiciona os dados da API
          this.contract = {
            ...response.contract,
            id: response.id,
            status: response.status,
            contract: response.contract,
            history: response.history || [],
            affiliate: response.affiliate || null,
            gateway_name: response.gateway_name || null,
            isPenultimateInstallment: response.isPenultimateInstallment || false,
            client: {
              ...(response.client || {})
            },
            current_period_end: response.current_period_end,
            start_date: response.start_date,
            cancellation_date: response.cancellation_date,
            created_at: response.created_at,
          };
          this.installmentSummary = response.currentInstallment + '/' + (response.totalInstallments || '∞');
        })
        .catch(err => {
          console.error('Erro ao buscar contrato:', err);
          this.$bvToast.toast(
            this.$t('seller.contracts.quick_view.text_252'),
            {
              title: this.$t('seller.contracts.quick_view.text_1812'),
              variant: 'danger',
              autoHideDelay: 5000,
              appendToast: true
            }
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    saleStatusLabel(status) {
      if (!status) return status;
      const key = `status_sales.${String(status).toLowerCase()}`;
      return this.$te(key) ? this.$t(key) : status;
    },
    getIconMethod(method) {
      return iconMethod(method);
    },
    getMethodLabel(method) {
      return textMethod(method);
    },
    openChargeAttempts(item) {
      this.chargeAttemptsCurrent = item.current_charge;
      this.chargeAttempts = [];
      this.chargeAttemptsLoading = true;
      this.$bvModal.show('contract-charge-attempts-modal');

      service
        .chargeAttempts(this.internalContractId, item.current_charge)
        .then(response => {
          this.chargeAttempts = (response && response.attempts) || [];
        })
        .catch(err => {
          console.error('Erro ao buscar retentativas:', err);
          this.$bvToast.toast('Não foi possível carregar as retentativas.', {
            title: this.$t('seller.contracts.quick_view.text_1812'),
            variant: 'danger',
            autoHideDelay: 5000,
            appendToast: true
          });
        })
        .finally(() => {
          this.chargeAttemptsLoading = false;
        });
    },
    resetChargeAttempts() {
      this.chargeAttempts = [];
      this.chargeAttemptsCurrent = null;
      this.chargeAttemptsLoading = false;
    },
    cancelContract() {
      let data = {
        id: this.internalContractId
      }

      service.destroy(data).then(response => {
        if (response.success) {
          this.is_btn_disable = true

          this.$bvToast.toast(
            this.$t('seller.contracts.quick_view.text_251'),
            {
              title: 'Contrato',
              variant: 'info',
              autoHideDelay: 5000,
              appendToast: true
            }
          )
          EventBus.$emit('relist-contracts')
          this.fetchContract()
        } else {
          this.$bvToast.toast(
            this.$t('seller.contracts.quick_view.text_252'),
            {
              title: this.$t('seller.contracts.quick_view.text_1812'),
              variant: 'danger',
              autoHideDelay: 5000,
              appendToast: true
            }
          )
        }
      })
    },
    setColors(coin) {
      if (coin === 'BRL') return 'color: rgba(0, 132, 92, 1);'
      if (coin === 'USD') return 'color: rgba(255, 203, 55, 1);'
      if (coin === 'EUR') return 'color: rgb(40 30 176);'
      if (coin === 'GBP') return 'color: rgba(0, 0, 0, 1);'
      return 'color: #21a56e;'
    },
    formatCreatedAt(item) {      
      const date = moment.utc(String(item.created_at)).subtract(3, 'hours');
      if (!date.isValid()) return '-';

      return date.format('DD/MM/YYYY');
    },
    formatTableDateValueExpiration(item) {
      let date;

      if (item.method === 'BOLETO') {        
        date = moment(item.boleto_expiration_date, 'YYYY-MM-DD', true);
      } else {        
        date = moment
          .utc(item.created_at, 'YYYY-MM-DD HH:mm:ss', true)
          .subtract(3, 'hours');
      }

      if (!date.isValid()) return '-';

      return date.format('DD/MM/YYYY');
    },
    getBeginningDateLabel() {
      return this.$t('seller.contracts.quick_view.text_2833');
    },
    getNextExpirationDateLabel() {
      if (this.contract.isPenultimateInstallment == true)
        return this.$t('seller.contracts.quick_view.text_2836');
      switch (this.contract.status) {
        case 'trialing':
          return this.$t('seller.contracts.quick_view.text_2834');
        case 'paid':
        case 'pending_payment':
        case 'unpaid':
          return this.$t('seller.contracts.quick_view.text_2835');
        case 'canceled':
          return this.$t('seller.contracts.quick_view.text_2838');
        case 'ended':
          return this.$t('seller.contracts.quick_view.text_2837');
        default:
          return this.$t('seller.contracts.quick_view.text_1792');
      }
    },
    getBeginningDateValue() {
      if (this.contract.created_at) {
        const date = moment(String(this.contract.created_at));
        return date.isValid() ? date.format('DD/MM/YYYY') : '-';
      }

      if (this.contract.start_date) {
        // Se a data já está no formato DD/MM/YYYY, retorna ela diretamente
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(this.contract.start_date)) {
          return this.contract.start_date;
        }
        // Senão, tenta formatar
        const date = moment(String(this.contract.start_date));
        return date.isValid() ? date.format('DD/MM/YYYY') : '-';
      }

      return '-';
    },
    formatPaidAt(paidAt) {
      if (!paidAt || paidAt === '') return '-';

      const date = moment.utc(String(paidAt)).subtract(3, 'hours');
      if (!date.isValid()) return '-';

      return date.format('DD/MM/YYYY');
    },
    open(contractId) {
      this.internalContractId = String(contractId);
      this.$emit('input', true);
    },
    formatDate(date) {
      if (date != null) {
        return new Date(date + 'T00:00:01').toLocaleDateString("pt-BR");
      }

      return "";
    },

    getStatusText(status) {
      return subscriptionStatusLabel(this.$t.bind(this), status);
    },


    getBadge(status) {
      if (!status || status === '-') return '';

      const norm = String(status).trim().toLowerCase();
      const statusMap = {
        'processing': 'badge badge-processing',
        'authorized': 'badge badge-paid',
        'paid': 'badge badge-paid',
        'canceled': 'badge badge-canceled',
        'ended': 'badge badge-ended',
        'refunded': 'badge badge-refunded',
        'waiting_payment': 'badge badge-waiting_payment',
        'pending_payment': 'badge badge-pending_payment',
        'refund_pending': 'badge badge-refund_pending',
        'pending_refund': 'badge badge-pending_refund',
        'refused': 'badge badge-refused',
        'chargedback': 'badge badge-chargedback',
        'delayed': 'badge badge-delayed',
        'trialing': 'badge badge-trialing',
        'unpaid': 'badge badge-unpaid',
      };
      return statusMap[norm] || '';
    },
    copyToClipboard() {
      if (!this.salesPage) {
        this.$bvToast.toast('Não foi possível gerar o link da assinatura', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
          autoHideDelay: 3000
        });
        return;
      }

      navigator.clipboard.writeText(this.salesPage).then(() => {
        this.$bvToast.toast('Link copiado com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
          autoHideDelay: 3000
        });
      }).catch((err) => {
        console.error("Erro ao copiar ou exibir toast:", err);
        this.$bvToast.toast('Erro ao copiar o link', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
          autoHideDelay: 3000
        });
      });
    },
    onHidden() {
      this.$emit('input', false);
      this.resetUrl();
    },
  }
}
</script>

<style lang="scss" scoped>
.open_boleto {
  color: #ff8200 !important;
  font-weight: 400;
  size: 14px;
}

.panel {
  .sumary {
    font-size: 13px;
    // padding-top: 20px;
    // padding-bottom: 20px;
  }

  .product-name {
    font-size: 16px;
    font-weight: 600;
    margin: 0;
  }

  .product-image {
    height: 170px;
    overflow: hidden;
    border-radius: 5px;
    background: #f5f2fc;
    display: flex;
    align-items: center;
  }

  .thumb-fake {
    width: 100%;
    color: silver;
    font-size: 32px;
    letter-spacing: 2px;
    justify-content: center;
  }

  .product-description {
    display: block;
    font-size: 14px;
    line-height: 1.5;
    color: #81858e;
    font-weight: normal;
  }
}

.name-product .hash {
  color: #6B7280;
  font-weight: inherit;
  font-family: Inter;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0%;
}

.container-sidebar {
  padding: 30px;
  padding-top: 0px;
}

.dados-campo {
  color: #374151;

  font-family: Inter;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0%;

}

.item-dados {
  // border: 1px solid ;
  padding: 2px 0 2px 0;
}

.item-dados-produto {
  margin: 24px 0 24px 0;
}

.item-dados+.item-dados {
  border-top: 0.5px solid #ededf0;
  margin: 24px 0 24px 0;
}

.titulo-item {
  margin: 24px 0;
  font-size: 18px;
  font-weight: 600;
  color: $black;
  margin-bottom: 15px;

  font-family: Inter;
  line-height: 24px;
  letter-spacing: 0%;

}

.label-campo {

  font-family: Inter;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0%;

  color: #6B7280;
}

.title-item {
  font-size: 11px;
  color: #81858e;
  display: block;
  font-weight: normal !important;
  margin-bottom: 3px;
}

.label-campo+.label-campo {
  margin-top: 5px;
}

.btn-flex {
  display: flex;
  flex-direction: column;
}

.btn-flex div {
  margin-bottom: 13px;
}

.btn-flex div button {
  width: 100%;
  height: 55px;
}

.btn-flex div button:hover {
  transform: none;
}

// collapse
.titulo-arrow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
}

.titulo-arrow.ativo {
  margin-bottom: 15px;
}

.titulo-arrow.ativo img {
  transition: 0.3s;
  transform: rotate(180deg);
}

// history
.titulo-collapse {
  font-size: 13px !important;
}

.history-item {
  padding: 15px 0;
  position: relative;
}

.history-item::before {
  left: -10px;
  top: 50%;
}

.history-item+.history-item {
  // padding-top: 15px;
  border-top: 1px solid #ededf0;
}

.sem-historico {
  margin-top: 20px;
  font-size: 14px;
  color: #81858e;
}

.whats-cliente {
  font-size: 14px;
  color: #2a63ab;
}

.whats-cliente svg {
  margin-left: 5px;
}

.product-main {
  font-size: 16px;
  display: grid;
  grid-template-columns: 0.5fr 3fr;
  gap: 20px;
  align-items: center;
}

.img-product {
  display: flex;
  align-items: center;
  justify-content: center;
}

.img-product,
.img-product img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #ededf0;
  object-fit: cover;
}

.name-product span {
  color: #81858e;
}

.name-product p {
  font-weight: 600;
}

.name-product-title {
  font-size: 18px;
  font-weight: 500;
}

.chip {
  width: 30px;
  height: 30px;
  font-size: 15px;
  font-weight: 700;
  border: 1px solid transparent;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
}

.sidebar-header-container {
  padding: 15px;
}

.sidebar-title-text {
  font-family: Inter, sans-serif;
  /* Adiciona fallback font */
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0%;
  color: #101828;
  /* Cor de exemplo, ajuste conforme Figma */
}

.table-custom {
  width: 100%;
  border: 1px solid #D7DAE2 !important;
}

.table-custom thead tr th {
  padding: 15px;
  font-size: 14px !important;
  color: #475467 !important;
}

.table-custom tbody tr td {
  padding: 15px;
  font-size: 14px !important;
  color: #475467 !important;
}

.rounded-table {
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 10px;
  /* Ajuste este valor conforme necessário */
  overflow: hidden;

  /* Estilo opcional para bordas */
  border: 1px solid #dee2e6;
  /* Cor da borda do Bootstrap */

  /* Para garantir que os cantos do cabeçalho também sejam arredondados */
  thead tr:first-child th:first-child {
    border-top-left-radius: 10px;
  }

  thead tr:first-child th:last-child {
    border-top-right-radius: 10px;
  }

  /* Para garantir que os cantos do rodapé também sejam arredondados (se aplicável) */
  tbody tr:last-child td:first-child {
    border-bottom-left-radius: 10px;
  }

  tbody tr:last-child td:last-child {
    border-bottom-right-radius: 10px;
  }

  /* Estilização do cabeçalho (thead) */
  thead {
    background-color: #f3f4f6 !important;
    /* Cor de fundo do cabeçalho */

    th {
      color: #475467 !important;
      /* Cor do texto */
      font-family: 'Inter', sans-serif !important;
      /* Fonte */
      font-weight: 500 !important;
      /* Peso da fonte */
      font-size: 12px !important;
      /* Tamanho da fonte */
      line-height: 18px !important;
      /* Altura da linha */
      letter-spacing: 0% !important;
      /* Espaçamento entre letras */
      border-top: none !important;
      /* Remove borda superior (opcional) */
      border-bottom: 1px solid #e5e7eb !important;
      /* Borda inferior (opcional) */
    }
  }

  /* Garante que os cantos arredondados do cabeçalho sejam mantidos */
  thead tr:first-child th:first-child {
    border-top-left-radius: 10px !important;
  }

  thead tr:first-child th:last-child {
    border-top-right-radius: 10px !important;
  }
}


.custom-button {
  height: 60px;
  border-radius: 4px;
  padding: 10px 0px;
  width: 100%;
  border: 0px;
  margin-bottom: 10px;
  gap: 15px;
  transition: all 0.2s ease-in-out;

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  svg {
    margin-left: 8px;
  }
}

.custom-button-encerrar-contrato {
  @extend .custom-button;
  background-color: #FEF2F2;
  color: #DC2626;

  &:hover:not(:disabled) {
    background-color: #FEE2E2;
  }
}

.custom-button-atribuir-afiliado {
  @extend .custom-button;
  background-color: #fff;
  border: 1px solid #D1D5DB;
  color: #111827;

  &:hover {
    background-color: #F9FAFB;
  }
}

.custom-button-atualizar-assinatura {
  @extend .custom-button;
  background-color: #0854C5;
  color: #fff !important;

  &:hover:not(:disabled) {
    background-color: #0A66DC;
  }

  span {
    color: #fff;
  }
}





/* Badge */
.badge {
  height: 36px;
  border-radius: 16px;
  padding: 8px 12px 8px 12px;
}

.badge-paid {
  background: #D1FAE5;
  color: #065F46
}

.badge-processing {
  background: #D6F0FF;
  color: #0854C5;
}

.badge-authorized {
  background: #D6F0FF;
  color: #0854C5;
}

.badge-refused {
  background: #FEE2E2;
  color: #92400E;
}

.badge-unpaid {
  background: #FEF3C7;
  color: #92400E;
}

.badge-refunded {
  background: #F3F4F6;
  color: #1F2937;
}

.badge-chargedback {
  background: #D1FAE5;
  color: #000000;
}

.badge-canceled {
  background: #D1FAE5;
  color: #000000
}

.badge-ended {
  background: #F2F4F7;
  color: #344054;
}

.badge-trialing {
  background: #FEF3C7;
  color: #92400E;
}

.badge-waiting_payment {
  background: #FEF3C7;
  color: #92400E;
}

.badge-pending_payment {
  background: #FEF3C7;
  color: #92400E;
}

.badge-refund_pending {
  background: #FEF3C7;
  color: #92400E;
}

.badge-canceled {
  background: #FEE4E2;
  color: #B42318;
}

.badge-ended {
  background: #F2F4F7;
  color: #344054;
}

.badge-unpaid {
  background: #FEF3C7;
  color: #92400E;
}

.badge-delayed {
  background: #FEF3C7;
  color: #92400E;
}

.badge-created {
  background: #D6F0FF;
  color: #0854C5;
}
.btn-transparent {
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0;
  width: auto;
  height: auto;
}

.attempt-method-two-cards {
  position: relative;
  display: inline-block;
  width: 1.2em;
}

.attempt-method-two-cards .TWO_CREDIT_CARDS {
  position: absolute;
  left: 5px;
  top: -5px;
}
</style>
